import { render, staticRenderFns } from "./listEntrega.vue?vue&type=template&id=644d015a"
import script from "./listEntrega.ts?vue&type=script&lang=js&external"
export * from "./listEntrega.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644d015a')) {
      api.createRecord('644d015a', component.options)
    } else {
      api.reload('644d015a', component.options)
    }
    module.hot.accept("./listEntrega.vue?vue&type=template&id=644d015a", function () {
      api.rerender('644d015a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/expedicao/listEntrega.vue"
export default component.exports